"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var form_1 = require("./form");
var event_1 = require("./event");
var Person = /** @class */ (function () {
    function Person() {
    }
    return Person;
}());
exports.Person = Person;
var Subscription = /** @class */ (function () {
    function Subscription(vouchers) {
        this.vouchers = vouchers;
    }
    Subscription.fromEvent = function (event) {
        var subscription = form_1.Form.buildFormData(event, { mode: 'object' });
        var vouchers = event_1.Event.generateVouchers(event);
        return tslib_1.__assign(tslib_1.__assign({}, subscription), new Subscription(vouchers));
    };
    Subscription.fromJson = function (json) {
        return json && Object.assign(new Subscription(json.vouchers || []), json);
    };
    return Subscription;
}());
exports.Subscription = Subscription;
//# sourceMappingURL=subscription.js.map